import { useQuery } from "@tanstack/react-query";
import { api } from "@/utils/axiosInterceptor";
import { invoiceDetailsApi } from "@/types/invoiceDetails";

export const useInvoiceDetails = (id: string) => {
	const {
		data: invoiceDetails,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["invoicesDetails", id],
		queryFn: async () => {
			const response = await api.get<invoiceDetailsApi>(`/invoice/${id}?isConsolidate=`)
			return response.data;
		},
	});

	const {
		data: eInvoiceDetails,
		isLoading: eInvoiceDetailsIsLoading,
		error: eInvoiceDetailsError,
	} = useQuery({
		queryKey: ["eInvoiceDetails", id],
		queryFn: async () => {
			const response = await api.get(`/e-invoices-details/${id}`)
			return response.data
		}
	})
	return {
		invoiceDetails,
		isLoading,
		error,
		eInvoiceDetails,
		eInvoiceDetailsIsLoading,
		eInvoiceDetailsError
	};
};
